module.exports = __webpack_public_path__ + "media/images/admin/icons/at-sign-453d6aa23f31b71d7e47fe667153245c.svg";